/**
 * Print component
 **/

import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { FaPrint } from "react-icons/fa";

const Print = () => {
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo1NTY=" }) {
        printOptions {
          printButtonText
        }
      }
    }
  `);
  const printOptions = data?.wpOption?.printOptions;

  return (
    <section
      className="section block m-section-half print:hidden anchor-heading"
      id="print"
    >
      <div className="container relative">
        <div className="text-center flex items-center justify-center relative">
          <button
            onClick={() => window.print()}
            aria-hidden
            className="text-3xl sm:text-7xl mr-4 text-gray-200 opacity-90 cursor-pointer"
            data-sal="slide-right"
          >
            <FaPrint />
          </button>
          <button className="btn btn-gray mr-4" onClick={() => window.print()}>
            {printOptions.printButtonText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Print;
